<template>
  <div class="brand-reviews">
    <div class="centered">
        <router-link :to="{ name: 'BrandAchievementCreator' }" class="button centered">Добавить достижение</router-link>
      </div>
    <draggable class="columns is-multiline mt-10 reviews-columns" v-model="brandAchievementsObject">
      <BrandAchievementItem 
        v-for="achievement in brandAchievementsObject" 
        :key="achievement.id" 
        :achievement="achievement"
        class="column is-half"
      />
    </draggable>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import deepcopy from 'deepcopy'
import BrandAchievementItem from 'components/BrandHistory/BrandAchievementItem'

export default {
  name: 'BrandAchievements',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['brandAchievements']),
    brandAchievementsObject: {
      get () { return deepcopy(this.brandAchievements) },
      set (value) {
        const valueCopy = deepcopy(value)
        for (let i = 0; i < valueCopy.length; i++) {
          valueCopy[i].order = i
        }
        this.updateBrandAchievementsOrder(valueCopy)
      }
    }
  },
  methods: {
    ...mapActions(['getBrandAchievements', 'updateBrandAchievementsOrder'])
  },
  created () {
    this.getBrandAchievements()
  },
  components: { BrandAchievementItem, draggable }
}
</script>
<style>
.reviews-columns {
  max-width: 1280px;
  margin: 0 auto !important;
}
</style>



// WEBPACK FOOTER //
// BrandAchievements.vue?1529f0f0